import { UPDATE_MODE_TYPE } from "../actionTypes";

export const updateModeType = data => {
  return {
    type: UPDATE_MODE_TYPE,
    modeType: data
  };
};